import { Grid, GridColumn as Column, GridToolbar } from "@progress/kendo-react-grid";
import { GridLoadingPanel } from "components/GridLoadingPanel";
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router";
import { fetchApi } from "services/api";
import { VehicleNavBar } from "./NavBar";
import { Title } from "utils/title";
import { VehicleOdometerViewModel } from "TypeGen/Assets/Odometers/vehicle-odometer-view-model";
import DateCell from "components/cells/DateCell";
import { ApiLink } from "TypeGen/api-link";
import { Button } from "@progress/kendo-react-buttons";
import { arrowRotateCwIcon, plusIcon } from "@progress/kendo-svg-icons";
import AddOdometerReading from "./AddOdometerReading";

type RouteComponentParams = {
  vehicleId: string;
};

type Response = {
  Odometer: VehicleOdometerViewModel[];
  Links: ApiLink[];
}

const VehicleOdometer = () => {
  const { vehicleId: vehicleIdParam } = useParams<RouteComponentParams>();
  const [loading, setLoading] = useState(true);
  const [showAddDialog, setShowAddDialog] = useState(false);
  const [data, setData] = useState<VehicleOdometerViewModel[]>([]);
  const [links, setLinks] = useState<ApiLink[]>([]);

  const refresh = useCallback(() => {
    setLoading(true);
    fetchApi(`/api/Asset/VehicleOdometer/${vehicleIdParam}`)
      .then((data: Response) => {
        setData(data.Odometer);
        setLinks(data.Links);
      })
      .finally(() => setLoading(false));
  }, [vehicleIdParam]);

  useEffect(() => {
    refresh();
  }, [vehicleIdParam, refresh]);

  return <>
    <VehicleNavBar id={vehicleIdParam} currentTab="Odometer" />
    <Title string="Odometer" />
    {showAddDialog && <AddOdometerReading
      VehicleID={parseInt(vehicleIdParam)}
      CloseDialog={(shouldRefresh) => {
        shouldRefresh && refresh();
        setShowAddDialog(false);
      }}
    />}
    {loading && <GridLoadingPanel />}
    <Grid data={data} dataItemKey="VehicleOdometerID">
      <GridToolbar>
        <Button
          title="Refresh"
          icon="refresh"
          svgIcon={arrowRotateCwIcon}
          onClick={refresh}
          disabled={loading}
        />
        {links.find(x => x.Name === 'Add') && <Button
            icon="plus"
            svgIcon={plusIcon}
            themeColor="primary"
            disabled={loading}
            onClick={() => setShowAddDialog(true)}
        > Reading
        </Button>}
      </GridToolbar>
      <Column field="DateTime" title="Reading Date" cells={{ data: DateCell }} />
      <Column field="Odometer" title="Reading" filter="numeric" format="{0:n0} mi" />
      <Column field="Location" title="Location" />
      <Column field="ModifiedDateTime" title="Entered Date" cells={{ data: DateCell }} />
      <Column field="ModifiedByFullName" title="Entered By" />
    </Grid>
  </>;
}

export default VehicleOdometer;